import { Box, BoxProps } from 'theme-ui';
import ColorTokens from '../../tokens/colors';

export interface CalendarDotProps extends Omit<BoxProps, 'color'> {
  size: number;
  color: keyof typeof ColorTokens;
}

const CalendarDot: React.FC<CalendarDotProps> = ({ color, size, sx, ...props }) => (
  <Box
    as="span"
    aria-label="calendar annotation"
    role="img"
    {...props}
    sx={{
      width: size,
      height: size,
      borderRadius: 'circular',
      m: 1,
      backgroundColor: color,
      ...sx
    }}
  />
);

CalendarDot.defaultProps = {
  size: 8
};

export default CalendarDot;
